import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';

import { Button, FModal, TextInput, Icons } from '@components';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { mdiDelete, mdiFolder } from '@mdi/js';
import { validaUploadEmprestimos } from '../../../../Emprestimos/FaleComSetorEmprestimo/utils/validaUpload';
import { deParaAnexos } from './DeParaAnexos';

export const AnexosPendentesEmprestimoForm = ({
  isOpen,
  onClose,
  onSubmit,
  anexosPendentes,
}) => {
  const yupRules = anexosPendentes.reduce((prev) => {
    return { ...prev, [`anexoEmprestimo`]: yup.mixed().required() };
  }, {});

  const motivo =
    anexosPendentes.find((anexo) => !!anexo.motivo)?.motivo || null;

  const [arquivosEnvio, setArquivosEnvio] = useState([]);

  function removeArquivo(nomeArquivo) {
    setArquivosEnvio(arquivosEnvio.filter((item) => item.name !== nomeArquivo));
  }

  return (
    <FModal isOpen={isOpen} close widthAuto onClose={onClose}>
      {motivo && (
        <>
          <p className="mb-2">Motivo(s): </p>
          {motivo.split(';').map((m) => (
            <p key={m} className="mb-2">
              {m};
            </p>
          ))}
        </>
      )}
      <Formik
        validateOnMount
        validationSchema={yup.object({
          ...yupRules,
        })}
        initialValues={{ anexoComplementar: null }}
        onSubmit={(value, { resetForm }) => {
          onSubmit(value);

          resetForm();
        }}
      >
        {}
        {({ isValid, handleSubmit }) => {
          return (
            <Form className="mt-4">
              <Field
                className="mb-3"
                name="Emprestimo"
                type="file"
                label="Anexe o contrato de emprestimo novamente"
                accept="image/*,.pdf"
              >
                {({ form }) => {
                  return (
                    <TextInput
                      className="mb-3"
                      name="anexoEmprestimo"
                      type="file"
                      multiple
                      label={deParaAnexos.Emprestimo}
                      accept="image/*,.pdf"
                      onChange={(e) => {
                        return validaUploadEmprestimos({
                          e,
                          form,
                          setModalIsOpen: onClose,
                          campo: 'anexoEmprestimo',
                          setArquivosEnvio,
                          arquivosEnvio,
                          isPendencia: true,
                        });
                      }}
                    />
                  );
                }}
              </Field>
              {arquivosEnvio.length > 0 && (
                <div>
                  <h4>Arquivos Selecionados</h4>
                  <hr />
                  {arquivosEnvio.map((item) => {
                    return (
                      <List key={item.name}>
                        <ListItem
                          secondaryAction={
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={() => removeArquivo(item.name)}
                            >
                              <Icons
                                path={mdiDelete}
                                color="var(--primary-color)"
                              />
                            </IconButton>
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <Icons
                                path={mdiFolder}
                                color="var(--primary-color)"
                              />
                            </Avatar>
                          </ListItemAvatar>
                          {item.name}
                        </ListItem>
                      </List>
                    );
                  })}
                </div>
              )}
              <hr className="mt-32 mt-xs-0 mb-32" />
              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid || arquivosEnvio.length === 0}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Enviar emprestimo
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </FModal>
  );
};
